import React from 'react'
import '../App.css'
import { useState } from 'react'
import Header from "../Components/Header.js"
import { HashLink  } from 'react-router-hash-link'

class Finding {
    constructor(text, link) {
        this.text = text
        this.link = link
    }
}

export default function Search() {
    const [searchstring, setSearchstring] = useState('')
    const [found, setFound] = useState([])

    let searchMap = require('../searchMap.json')
    let findings = []

    const SearchString = (searchString) => {
        setSearchstring(searchString)
        for (let i = 0; i < searchMap.Gite.length; i++) {
            let search = searchString.toLocaleLowerCase()
            let title = searchMap.Gite[i].title.toLocaleLowerCase()
            if (title.includes(search)) {
                let finding = new Finding(searchMap.Gite[i].title, searchMap.Gite[i].page+searchMap.Gite[i].id)
                findings.push(finding)
            }
        }
        setFound(findings)
    }

    const scrollWithOffset = (el) => {
        const checkImages = () => {
            // Check if all the images are loaded
            const imgs = el.parentElement.querySelectorAll('img')
            const allLoaded = Array.from(imgs).every(img => img.complete)

            if (allLoaded) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' })
            } else {
            // if not try again in 100ms
            setTimeout(checkImages, 100)
            }
        };
        checkImages()
    }

    return (
        <>
            <Header />
            <div className='row'>
                <div className='fieldSearch col'>
                    <input type="text" className="textSearch" placeholder="Cerca una cima..." value={searchstring} id={searchstring} onChange={(e) => SearchString(e.target.value)} />
                </div>
            </div>
            <div className='row pt-3'>
                <div className='col ps-4'>
                {found.map((item, index) => (
                    <div className='textFound' key={index}>
                       <HashLink scroll={scrollWithOffset} smooth to={item.link}>{item.text}</HashLink><p></p>      
                    </div>
                    ))}                    
                </div>
            </div>
        </>
    )   
}
